import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Spinner from './spinner';

class GifThumb extends Component { 
    static defaultProps = {
        showAttribution: true
    }

    state = {
        loading: true
    }

    handleClick = () => {
        this.props.onClick && this.props.onClick(this.props.gifProps);
    }

    handleLoad = () => {
        this.setState({
            loading: false
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className={'gif-thumb' + (this.props.selectable ? ' selectable' : '') + (this.state.loading ? ' loading' : '')} onClick={this.handleClick}>
                {
                    this.state.loading ? <Spinner size="small" /> : null
                }

                <img src={this.props.url} alt="gif" width={this.props.width} height={this.props.height} onLoad={this.handleLoad} />

                {
                    this.props.showAttribution ? (
                        <div className="gif-attribution">
                            { t('Powered by', { name: 'GIPHY' }) }
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

export default withTranslation('common')(GifThumb);
